export const IconCloseMenu = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M3.138 19q-.484 0-.81-.335A1.14 1.14 0 0 1 2 17.833q0-.495.327-.83.327-.336.811-.336h12.518q.483 0 .81.335t.328.831-.327.832a1.09 1.09 0 0 1-.811.335zm16.956-1.983-4.097-4.2a1.13 1.13 0 0 1-.341-.817q0-.466.341-.817l4.097-4.2q.312-.32.796-.32t.797.32q.313.32.313.817t-.313.817L18.387 12l3.3 3.383q.313.32.313.817 0 .495-.313.817-.313.32-.797.32-.483 0-.796-.32m-16.956-3.85q-.484 0-.81-.336A1.14 1.14 0 0 1 2 12q0-.496.327-.831.327-.336.811-.336h9.104q.483 0 .81.336.328.335.328.831t-.327.831a1.09 1.09 0 0 1-.811.336zm0-5.834q-.484 0-.81-.335A1.14 1.14 0 0 1 2 6.167q0-.495.327-.832Q2.654 5 3.138 5h12.518q.483 0 .81.335.328.336.328.832t-.327.83a1.09 1.09 0 0 1-.811.336z" />
    </svg>
  );
};
